import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";
import fileDownload from "js-file-download";

const listSales = async (params: any) => {
  const url = endpoints.SALES;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params
  });

  return response;
};

const getAttendees = async (params: any) => {
  const url = endpoints.SALES + "/attendance";

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params
  });

  return response;
};

const createSales = async (params: any) => {
  const url = endpoints.SALES;
  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  })
  return response;
};

const getSales = async (id: any) => {
  const url = endpoints.SALES + `/${id}`;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  })
  return response;
};

const updateSales = async (params: any) => {
  const url = endpoints.SALES + `/${params.id}`;
  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  })
  return response;
};

const monthlySummary = async (params: any) => {
  const url = endpoints.SALES + "/monthly";

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params
  });

  return response;
};

const salesPerformance = async (params: any) => {
  const url = endpoints.SALES + "/sales-performance";

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params
  });

  return response;
};

const salesPerformanceRange = async (params: any) => {
  const url = endpoints.SALES + "/sales-performance-range";

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params
  });

  return response;
};

const deleteSales = async (id: number) => {
  const url = endpoints.DETAIL_SALES(id);

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const testOcr = async (params: FormData) => {
  const url = endpoints.SALES + "/test-ocr";

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

const downloadMonthlyReport = async (params: any) => {
  const url = endpoints.SALES + "/export-monthly";
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `monthly_report_${params.month}_${params.year}.xlsx`);
    });
};

const downloadKertasReport = async (params: any) => {
  const url = endpoints.SALES + "/export-kertas";
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `kertas_report_${params.month}_${params.year}.xlsx`);
    });
};

const downloadKertasReportLast = async (params: any) => {
  const url = endpoints.SALES + "/export-kertas-last";
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `kertas_report_last_${params.month}_${params.year}.xlsx`);
    });
};

const downloadSalesPerformance = async (params: any) => {
  const url = endpoints.SALES + "/export-sales-performance";
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `sales_performance_${params.month}_${params.year}.xlsx`);
    });
};

const downloadMonthlySalesYearly = async (params: any) => {
  params.branch_ids = params.branch_ids?.join(",");
  const url = endpoints.SALES + "/monthly-sales-yearly";
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `monthly_sales_${params.year}.xlsx`);
    });
};

const downloadGroupMonthlySalesYearly = async (params: any) => {
  params.branch_ids = params.branch_ids?.join(",");
  const url = endpoints.SALES + "/group-monthly-sales-yearly";
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params,
      responseType: "arraybuffer",
    })
    .then((res) => {
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, `group_monthly_sales_${params.year}.xlsx`);
    });
};

const services = {
  listSales,
  createSales,
  monthlySummary,
  getAttendees,
  updateSales,
  getSales,
  deleteSales,
  testOcr,
  downloadMonthlyReport,
  downloadKertasReport,
  downloadKertasReportLast,
  downloadSalesPerformance,
  salesPerformance,
  salesPerformanceRange,
  downloadMonthlySalesYearly,
  downloadGroupMonthlySalesYearly,
};

export default services;
